export const notFoundPageIconTokens = [
    'arrowRight',
    'briefcase',
    'folder',
    'home',
    'messageCircle',
    'phone',
    'search',
    'users',
] as const;

export type NotFoundPageIconToken = (typeof notFoundPageIconTokens)[number];

export const notFoundPageTokens = {
    colors: {
        accent: '#1155d9',
        accentDark: '#0b43b9',
        accentSoft: 'rgba(17, 85, 217, 0.1)',
        accentWash: 'rgba(17, 85, 217, 0.06)',
        accentContrast: '#ffffff',
        background: '#f8fbff',
        surface: '#ffffff',
        text: '#071125',
        textSoft: '#53627a',
        textMuted: '#73829b',
        border: 'rgba(7, 17, 37, 0.12)',
        divider: 'rgba(7, 17, 37, 0.1)',
        shadow: '0 24px 70px rgba(15, 35, 74, 0.12)',
        illustrationBackground: 'rgba(17, 85, 217, 0.08)',
        illustrationSoft: 'rgba(17, 85, 217, 0.16)',
    },
    radius: {
        button: 8,
        search: 8,
        panel: 8,
        icon: 8,
    },
    sizes: {
        maxWidth: 1440,
    },
    typography: {
        fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
    defaults: {
        statusCode: '404',
        title: 'Oops! Page not found.',
        description:
            "The page you're looking for may have been moved, deleted, or never existed. Don't worry, we're here to help you find what you need.",
        searchPlaceholder: 'Search our website',
        suggestionsTitle: 'You might be looking for',
    },
} as const;

export type NotFoundPageColorToken = keyof typeof notFoundPageTokens.colors;
